$.SubjectOrderImporter = function(options) {
	var obj = $.extend(true, {
		importFromFile: function(file) {
			Papa.parse(file, {
				header: true,
				delimiter: ',',
				skipEmptyLines: true,
				dynamicTyping: true,
				complete: function(results) {
					var orders = obj.getOrdersFromRecords(results);
					obj.saveOrders(orders);
				},
				error: function(error, file) {
					$.Alert('Error', 'Failed to parse file');
				}
			});
		},
		getOrdersFromRecords: function(records) {
			var newOrders = [];
			for(var i = 0; i < records.data.length; i++) {
				var data = records.data[i];
				var order = {};
				var errors = [];
				
				if($.isInit(data.FirstName)) {
					order.firstName = data.FirstName;
				} else if($.isInit(data['First Name'])) {
					order.firstName = data['First Name'];
				} else {
					errors.push('First Name');
				}

				if($.isInit(data.LastName)) {
					order.lastName = data.LastName;
				} else if($.isInit(data['Last Name'])) {
					order.lastName = data['Last Name'];
				} else {
					errors.push('Last Name');
				}

				if($.isInit(data.Grade)) {
					order.grade = data.Grade;
				} else {
					errors.push('Grade');
				}

				if($.isInit(data.Teacher)) {
					order.teacher = data.Teacher;
				} else if($.isInit(data['Custom 3'])) {
					order.teacher = data['Custom 3'];
				} else {
					errors.push('Teacher');
				}

				if($.isInit(data.Quantity)) {
					order.quantity = data.Quantity;
				} else if($.isInit(data.Qty)) {
					order.quantity = data.Qty;
				} else if($.isInit(data.Packages)) {
					order.quantity = (data.Packages.match(/;/ig) || []).length + 1;
				} else {
					order.quantity = 1;
				}

				if($.isInit(data.Total)) {
					order.orderTotal = data.Total;
				} else if($.isInit(data['Sub Total'])) {
					order.orderTotal = data['Sub Total'];
				} else {
					errors.push('Total');
				}

				if(order.orderTotal) {
					if(order.orderTotal.replace) {
						order.orderTotal = $.trim(order.orderTotal.replace('$', ''));
					}

					order.orderTotal = Math.round(parseFloat(order.orderTotal) * 100);
				}

				if(data.Personalization) {
					order.personalizationNotes = data.Personalization;
				}

				if(data.Date) {
					order.createdAt = data.Date;
				}
				if(data['Binding Type']) {
					order.bindingType = data['Binding Type'];
				}
				order.subjectId = this.getMatchingSubjectId(data, order);

				if(errors.length) {
					$.Alert('Error', 'Failed to import CSV.  The following fields are missing: ' + errors.joinAnd(', ', ' and '));
					return;
				} else {
					newOrders.push(order);
				}
			}

			return newOrders;
		},
		getMatchingSubjectId: function(record, order) {
			for(var i = 0; i < this.subjects.length; i++) {
				var subject = this.subjects[i];

				if($.trim(subject['First Name']).toLowerCase() == $.trim(order.firstName).toLowerCase() && $.trim(subject['Last Name']).toLowerCase() == $.trim(order.lastName).toLowerCase() &&
						$.trim(subject['Teacher']).toLowerCase() == $.trim(order.teacher).toLowerCase() && $.trim(subject['Grade']).toLowerCase() == $.trim(order.grade).toLowerCase()) {
					// I trust what the subject data says to be more accurate
					order.firstName = subject['First Name'];
					order.lastName = subject['Last Name'];
					order.teacher = subject['Teacher'];
					order.grade = subject['Grade'];
					
					return subject.id;
				}
			}
		},
		saveOrders: function(orders) {
			$.ajax({
				url: 'ajax/subjectOrders.php',
				type: 'POST',
				dataType: 'json',
				data: {
					jobId: $.currentLoadedSchool.jobId,
					orders: JSON.stringify(orders)
				},
				success: function(data) {
					obj.onComplete({
						orders: data.orders
					});
				},
				error: function() {
					$.Alert('Error', 'Failed to import orders');
				}
			});
		},

		subjects: []
	}, options);

	return obj;
};